import { PaginatedResponse, QueryParamsBase } from "@/types/types";
import { User } from "@/types/user";
import { axiosInstance } from "../../axios/axiosInstance";

export const getUsers = async (
  params?: QueryParamsBase & { select?: string[] },
): Promise<PaginatedResponse<User>> => {
  const { data } = await axiosInstance.get("/v2/users", {
    params,
  });
  return data;
};

export async function deleteUser(id: User["id"]) {
  const { data } = await axiosInstance.delete(`/users/${id}`);
  return data;
}

//store
export async function createUser(values: User) {
  const { data } = await axiosInstance.post(`/users`, values);
  return data;
}

//update
export async function updateUser(values: User) {
  const { data } = await axiosInstance.patch(`/users/${values.id}`, values);
  return data;
}